import Input from "../FormElements/Input/Input.js";
import Select from "../FormElements/Select/Select.js";
import Checkbox from "../FormElements/Checkbox";
import SubmitButton from "../FormElements/SubmitButton/SubmitButton.js";
import { RadioButtonGroup } from "../FormElements/Radio";

const formElements = [Input,Select,Checkbox,RadioButtonGroup];

export const isFormElements = (node) => (formElements.indexOf(node.type)!=-1  );

export const isSubmitButton = (node) => node == SubmitButton;
